import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import InterestedMembersLayer from "../components/InterestedMembersLayer";

const InterestedMembersPage = () => {
    return (
        <MasterLayout>
            <InterestedMembersLayer />
        </MasterLayout>
    );
};

export default InterestedMembersPage;
